export default "__VITE_ASSET__Dc2l0Ajr__"